import { combineReducers } from "../utils";
import startupStateReducer from './startupStateReducer';
import uiReducer from "./uiReducer";
import customerReducer from "./customerReducer";
import userReducer from "./userReducer";
import journeyReducer from "./journeyReducer";
import signatureReducer from "./signatureReducer";
import valuationReducer from "./valuationReducer";
import notificationReducer from "./notificationReducer";


export default combineReducers({
    startupState: startupStateReducer,
    ui: uiReducer,
    customerInfo: customerReducer,
    userInfo: userReducer,
    jourenyInfo: journeyReducer,
    signatures: signatureReducer,
    valuationInfo:valuationReducer,
    notifications: notificationReducer
});